var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_796_989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.80764 19.6342L2.8628 21.4643C3.08204 21.8495 3.39764 22.1525 3.76838 22.3731L7.55325 19.6896L7.56014 15.8369L3.7831 14.1352L3.83795e-06 15.8234C-0.000746162 16.2495 0.108426 16.6758 0.327707 17.0611L1.80764 19.6342Z",
    fill: "#0066DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0137 8.14724L12.2112 3.12861L8.24536 1.59753C7.87383 1.81682 7.55714 2.11864 7.3365 2.50311L0.332109 14.5868C0.111516 14.9713 0.00075 15.3973 0 15.8233L7.56014 15.8368L12.0137 8.14724Z",
    fill: "#00AD3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0135 8.14725L15.6465 6.19284L15.8053 1.61104C15.4345 1.39045 15.0086 1.27973 14.5687 1.27893L9.48285 1.26984C9.04298 1.26904 8.61665 1.392 8.24512 1.59754L12.0135 8.14725Z",
    fill: "#00831E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.44 15.8528L7.56027 15.8369L3.76855 22.3731C4.13929 22.5937 4.56524 22.7044 5.00507 22.7052L18.9707 22.7301C19.4106 22.7309 19.8369 22.608 20.2084 22.4024L20.2231 18.0121L16.44 15.8528Z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2087 22.4025C20.5802 22.1832 20.8969 21.8814 21.1175 21.4969L21.5587 20.7417L23.6684 17.1028C23.8889 16.7184 23.9997 16.2925 24.0005 15.8663L19.6307 13.567L16.4541 15.8529L20.2087 22.4025Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1917 8.57423L16.7111 2.51985C16.4918 2.13454 16.1762 1.83159 15.8054 1.61099L12.0137 8.1472L16.4398 15.8527L23.9862 15.8662C23.9869 15.4401 23.8777 15.0138 23.6585 14.6285L20.1917 8.57423Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_796_989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.5f98085a3fa685f9ff7659d2b2e271d6.svg";
export { ForwardRef as ReactComponent };